// Auto-generated file created by svgr-cli source svg-template.js
// Do not edit directly
import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef, memo } from 'react'
const SvgIconLog = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg xmlns='http://www.w3.org/2000/svg' width={props.width || 16} height={props.height || 16} fill='none' viewBox='0 0 16 16' ref={ref} {...props}>
        <path
            fill='currentcolor'
            d='M4.667 1.333C3.747 1.333 3 2.081 3 3v10c0 .92.747 1.667 1.667 1.667h6.666c.92 0 1.667-.748 1.667-1.667V5.5H9.667a.83.83 0 0 1-.834-.833V1.333zm5 0v3.334H13zM5.917 8h4.166c.23 0 .417.188.417.417s-.187.416-.417.416H5.917a.42.42 0 0 1-.417-.416c0-.23.188-.417.417-.417m0 1.667h4.166c.23 0 .417.187.417.416 0 .23-.187.417-.417.417H5.917a.42.42 0 0 1-.417-.417c0-.229.188-.416.417-.416m0 1.666h4.166c.23 0 .417.188.417.417 0 .23-.187.417-.417.417H5.917a.42.42 0 0 1-.417-.417c0-.23.188-.417.417-.417'
        />
    </svg>
)
const ForwardRef = forwardRef(SvgIconLog)
const Memo = memo(ForwardRef)
export default Memo
